import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "./HomePage.css";

import theReflexChallengeImage from "../../assets/ActivityTabs/the_reflex_challenge.png";
import visionTTImage from "../../assets/ActivityTabs/vision_tt.png";
import rapidClickerImage from "../../assets/ActivityTabs/rapid_clicker.png";
import travelPassportImage from "../../assets/ActivityTabs/travel_passport.png";
import wikiSpeedrunImage from "../../assets/ActivityTabs/wiki_speedrun.png";
import colorMatchImage from "../../assets/ActivityTabs/color_match.png";
import quizttImage from "../../assets/ActivityTabs/quiz_tt.png";
import guessTheCountryImage from "../../assets/ActivityTabs/guess_the_country.png";
import mathBlitzImage from "../../assets/ActivityTabs/math_blitz.png";
import catchTheBalls from "../../assets/ActivityTabs/catch_the_balls.png";
import memoryTest from "../../assets/ActivityTabs/memory_test.png";

const activities = [
  { name: "TheReflexChallenge", src: theReflexChallengeImage },
  { name: "ColorMatch", src: colorMatchImage },
  { name: "CatchTheBalls", src: catchTheBalls },
  { name: "RapidClicker", src: rapidClickerImage },
  { name: "GuessCountryGame", src: guessTheCountryImage },
  { name: "MemoryTest", src: memoryTest },
  { name: "WikiSpeedrun", src: wikiSpeedrunImage },
  { name: "MathBlitz", src: mathBlitzImage },
  { name: "QuizTT", src: quizttImage },
  { name: "TravelPassport", src: travelPassportImage },
  { name: "VisionTT", src: visionTTImage },
];

export default function HomePage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const images = activities.map((a) => {
      const img = new Image();
      img.src = a.src;
      return img;
    });

    const preload = Promise.all(
      images.map(
        (img) =>
          new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          })
      )
    );

    preload.then(() => setIsLoading(false));
  }, []);

  if (isLoading) {
    return (
      <div className="homePage-loader">
        <div className="spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="homePage-main">
      <div className="homePage-main-content">
        <div className="homePage-activities">
          {activities.map((activity) => (
            <img
              key={activity.name}
              src={activity.src}
              alt={activity.name}
              className="homePage-activity-tab"
              onClick={() => navigate(`/activity/${activity.name}`)}
            />
          ))}
        </div>
        {/* <div className="homePage-ad-slot"></div> */}
        <div className="homePage-footer">
          <p>Hey, feel free to use the following links :p</p>
          <div className="homePage-footer-links">
            <a
              href="https://www.linkedin.com/in/yashjoshi009"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                window.gtag &&
                window.gtag("event", "click", {
                  event_category: "external_link",
                  event_label: "LinkedIn",
                })
              }
            >
              💼 LinkedIn
            </a>
            <a
              href="https://mail.google.com/mail/?view=cm&to=joshi.yashshashikant@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                window.gtag &&
                window.gtag("event", "click", {
                  event_category: "external_link",
                  event_label: "Gmail",
                })
              }
            >
              📧 Gmail
            </a>
            <a
              href="https://buymeacoffee.com/breakt1me"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                window.gtag &&
                window.gtag("event", "click", {
                  event_category: "external_link",
                  event_label: "BuyMeACoffee",
                })
              }
            >
              ☕ Buy me a coffee
            </a>

            <a
              href="/privacy-policy"
              onClick={() =>
                window.gtag &&
                window.gtag("event", "click", {
                  event_category: "navigation",
                  event_label: "Privacy_Policy",
                })
              }
            >
              📄 Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
